import React from 'react';
import propTypes from 'prop-types';
import { Loader2 } from 'lucide-react';

const Spinner = ({ message, showMessage, showLarge }) => (
  <div data-testid="spinner" className="flex justify-center items-center">
    <Loader2
      data-testid="i-ddeb4756"
      className={`animate-spin text-green-cm mx-auto ${showLarge ? 'h-12 w-12' : 'h-5 w-5'}`}
    />
    {showMessage && (
      <span data-testid="span-28023fae" className="pl-2">
        {message}
      </span>
    )}
  </div>
);

Spinner.propTypes = {
  message: propTypes.string,
  showMessage: propTypes.bool,
};

Spinner.defaultProps = {
  message: 'Loading...',
  showMessage: true,
};

export default Spinner;
